import { useCallback } from 'react'

import { useChannels } from '~/app/state/hooks'
import { updateChannel } from '~/modules/account/utils'
import { usePostsContext } from '~/modules/post/context'

export default function useEventCountersUpdated() {
  const { getChannels, mutateChannels } = useChannels()

  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  const [_, { get: getPost, add: addPost, update: updatePost }] =
    usePostsContext()

  return useCallback(
    ({ post, channel }: { post: any; channel: any }) => {
      if (!post || !channel) {
        console.error(
          '[useEventCountersUpdated] Post or channel data is missing.',
        )
        return
      }

      const currPost = getPost(post.id)

      if (currPost) {
        updatePost(post.id, post)
      } else {
        addPost(post)
      }

      // IMPROVEMENT: If the post did not exist and
      // it was not saved we could avoid updating
      // the channel counters if they were recently updated.
      const channels = getChannels()

      const updatedChannels = updateChannel(channels, channel.id, {
        updatedAt: channel.updatedAt,
        totalPendingComments: channel.totalPendingComments,
        labelsCount: channel.labelsCount,
        backfillingComplete: channel.backfillingComplete,
      })
      updatedChannels && mutateChannels(updatedChannels)
    },
    [addPost, updatePost],
  )
}
